import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as actions from '../actions/properties';

const initialState = fromJS({
  data: [],
  property: {
    data: [],
    state: null,
  },
  taxingUnits: {
    data: [],
    state: null,
  },
  state: null,
  stateUpdate: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_PROPERTY_START: {
      return state.setIn(['property', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PROPERTY_SUCCESS: {
      return state
        .setIn(['property', 'state'], fetchingState.LOADED)
        .setIn(
          ['property', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.FETCH_PROPERTY_ERROR: {
      return state.setIn(['property', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PROPERTY_ASSOCIATION_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PROPERTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['state'], fetchingState.LOADED)
        .setIn(['data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_PROPERTY_ASSOCIATION_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }

    case actions.FETCH_TAXING_UNITS_START: {
      return state.setIn(['taxingUnits', 'state'], fetchingState.START);
    }
    case actions.FETCH_TAXING_UNITS_SUCCESS: {
      return state
        .setIn(['taxingUnits', 'state'], fetchingState.FETCHING)
        .setIn(
          ['taxingUnits', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_TAXING_UNITS_ERROR: {
      return state.setIn(['taxingUnits', 'state'], fetchingState.ERROR);
    }

    case actions.INSERT_PROPERTY_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.INSERT_PROPERTY_SUCCESS: {
      return state.setIn(['state'], fetchingState.LOADED);
    }
    case actions.INSERT_PROPERTY_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }

    case actions.INSERT_PROPERTY_ASSOCIATION_START: {
      return state.setIn(['state'], fetchingState.FETCHING);
    }
    case actions.INSERT_PROPERTY_ASSOCIATION_SUCCESS: {
      return state.setIn(['state'], fetchingState.LOADED);
    }
    case action.INSERT_PROPERTY_ASSOCIATION_ERROR: {
      return state.setIn(['state'], fetchingState.ERROR);
    }

    case actions.UPDATE_PROPERTY_START: {
      return state.set('stateUpdate', fetchingState.FETCHING);
    }
    case actions.UPDATE_PROPERTY_SUCCESS: {
      const { pID } = action.payload;

      return state.set('stateUpdate', fetchingState.LOADED).set(
        'data',
        fromJS(
          state
            .get('data')
            .toJS()
            .map(property =>
              property.pID !== pID ? property : action.data.results[0],
            ),
        ),
      );
    }
    case actions.UPDATE_PROPERTY_ERROR: {
      return state.set('stateUpdate', fetchingState.ERROR);
    }

    case actions.SET_FINAL_VALUE_SUCCESS:
    case actions.SET_OPINION_VALUE_SUCCESS: {
      const properties = state.get('data').toJS();
      return state.setIn(
        ['data'],
        fromJS(
          properties.map(p => {
            if (p.assocID === action.assocID) {
              return action.data.results[0];
            }
            return p;
          }),
        ),
      );
    }

    default: {
      return state;
    }
  }
};
